/**
 * 服务端随 HTML 注入的首屏上下文。
 *
 * 由 server/modules/view/view.controller.ts 写入 window.__APP_CONTEXT__，
 * 首屏直接拿到登录态，省掉一次接口往返和随之而来的闪烁。
 */
export interface AppContext {
  userId: string;
  userName: string;
  avatar: string;
  email: string;
  roles: string[];
  authenticated: boolean;
  loginUrl: string;
  appName: string;
  basename: string;
}

const FALLBACK: AppContext = {
  userId: '',
  userName: '',
  avatar: '',
  email: '',
  roles: [],
  authenticated: false,
  loginUrl: '/api/auth/login',
  appName: 'AI 账号管理',
  basename: '/',
};

/** 读取首屏上下文；开发态由 vite 直出 HTML，此时拿不到，回退为未登录 */
export function getAppContext(): AppContext {
  const raw = (window as unknown as { __APP_CONTEXT__?: Partial<AppContext> })
    .__APP_CONTEXT__;
  if (!raw || typeof raw !== 'object') {
    return FALLBACK;
  }
  return { ...FALLBACK, ...raw };
}
